module.exports = __webpack_public_path__ + "../static/img/base_superficial.38e99624.png";